import { render, staticRenderFns } from "./RegistrationBox.vue?vue&type=template&id=50e556cc&scoped=true&"
import script from "./RegistrationBox.vue?vue&type=script&lang=js&"
export * from "./RegistrationBox.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationBox.vue?vue&type=style&index=0&id=50e556cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e556cc",
  null
  
)

export default component.exports